function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var PATH_DELIMTER = '/';
function joinPaths(path1, path2) {
  if (!path1 && !path2) {
    return '';
  }

  if (path1 && !path2) {
    return path1;
  }

  if (!path1 && path2) {
    return path2;
  }

  if (path1.endsWith(PATH_DELIMTER) && path2.startsWith(PATH_DELIMTER)) {
    return "".concat(path1).concat(path2.substring(1));
  }

  if (!path1.endsWith(PATH_DELIMTER) && !path2.startsWith(PATH_DELIMTER)) {
    return "".concat(path1).concat(PATH_DELIMTER).concat(path2);
  }

  return "".concat(path1).concat(path2);
}

var DEFAULT_BRAND = 'path';

function getPlatformUrl(platform) {
  if (platform) {
    if (platform.toUpperCase() === 'DEMO') {
      return 'https://sdkweb-test.idcheck.io/v2';
    } else {
      return platform;
    }
  }

  return 'https://sdkweb.idcheck.io/v2';
}

function extractFromUrl(url) {
  var regex = /(.*)\/(.*)\/(.*)/;
  var match = url.match(regex);
  return {
    platformUrl: match[1],
    brand: match[2],
    uid: match[3]
  };
}

function getFrameUrl(params, platform) {
  var extraParams = '?iframe=true';

  if ('url' in params) {
    return "".concat(params.url).concat(extraParams);
  } else {
    var platformUrl = getPlatformUrl(platform);
    return joinPaths(platformUrl, "/".concat(DEFAULT_BRAND, "/").concat(params.uid).concat(extraParams));
  }
}
function extractOnboardingData(params, platform) {
  if ('url' in params) {
    return extractFromUrl(params.url);
  } else {
    return {
      platformUrl: getPlatformUrl(platform),
      uid: params.uid,
      brand: DEFAULT_BRAND
    };
  }
}

var IFRAME_READY_TIMEOUT = 30000; // ms

var registeredListener;

function injectScript(id, src) {
  return new Promise(function (resolve, reject) {
    var head = document.getElementsByTagName('head')[0];

    if (document.getElementById(id)) {
      // the script has already been injected
      resolve();
      return;
    }

    var script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = src;

    script.onload = function () {
      return resolve();
    };

    script.addEventListener('error', function () {
      return reject('Error loading script.');
    });
    script.addEventListener('abort', function () {
      return reject('Script loading aborted.');
    });
    head.appendChild(script);
  });
}
/**
 * Wait for iframe.contentWindow to be initialized.
 * iframe.contentWindow is only initialized once the webpage has been fully
 * loaded in the iframe. So, we need to wait for it to be available before
 * we can be able to call the postMessage() API.
 * @param iframe: the iframe element
 * @param startTs: timer start duration
 * @returns {Promise<any>}
 */


function waitForIframeReady(iframe) {
  var startTs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getTime();
  return new Promise(function (resolve, reject) {
    if (iframe.contentWindow) {
      resolve();
    } else if (new Date().getTime() - startTs > IFRAME_READY_TIMEOUT) {
      reject("iframe ready timeout.");
    } else {
      setTimeout(function () {
        waitForIframeReady(iframe, startTs).then(resolve)["catch"](reject);
      }, 10);
    }
  });
}

var ScriptLoader = /*#__PURE__*/function () {
  function ScriptLoader(platformUrl) {
    _classCallCheck(this, ScriptLoader);

    this.cdnUrl = joinPaths(platformUrl, '/assets/js');
  }

  _createClass(ScriptLoader, [{
    key: "injectConfig",
    value: function injectConfig() {
      return injectScript('idcheckio-sdk-config', "".concat(this.cdnUrl, "/config.js"));
    }
  }, {
    key: "injectCore",
    value: function injectCore() {
      return injectScript('idcheckio-sdk-core', "".concat(this.cdnUrl, "/idcheckio-sdk-core-stable.js"));
    }
  }, {
    key: "injectLang",
    value: function injectLang(lang) {
      return injectScript("axt-idcheckio-i18n-".concat(lang), "".concat(this.cdnUrl, "/i18n-").concat(lang, ".min.js"));
    }
  }, {
    key: "injectWidget",
    value: function injectWidget(id) {
      switch (id) {
        case 'LIVENESS':
          return injectScript('axt-liveness-script', "".concat(this.cdnUrl, "/axt-liveness-stable.js"));

        case 'CAMERA_CAPTURE':
          return injectScript('axt-camera-capture-script', "".concat(this.cdnUrl, "/axt-camera-capture.js"));

        default:
          return new Promise(function (resolve, reject) {
            reject(new Error("Cannot find widget ".concat(id, ".")));
          });
      }
    }
  }]);

  return ScriptLoader;
}();

var IdCheckIo = /*#__PURE__*/function () {
  function IdCheckIo(config) {
    _classCallCheck(this, IdCheckIo);

    this.config = config || {};
    this.eventHandlers = {};
    this.mode = this.config.mode ? this.config.mode.toUpperCase() : 'IFRAME'; // fix iframe listeners when multiple instance
    // remove previous listener

    this.handleMessage = this.handleMessage.bind(this);

    if (registeredListener) {
      window.removeEventListener('message', registeredListener);
    }
  }

  _createClass(IdCheckIo, [{
    key: "on",
    value: function on(eventName, callback) {
      if (eventName === 'ready') {
        this.onReadyCallback = callback;
      } else if (this.instance) {
        this.instance.on(eventName, callback);
      } else {
        this.eventHandlers[eventName] = callback;
      }
    }
    /**
     * Initialize sdkweb element
     * @param { element, uid } onboarding parameters
     */

  }, {
    key: "init",
    value: function init(params) {
      if (this.mode === 'DOM') {
        this.initLibrary(params);
      } else {
        this.initFrame(params);
      }
    }
  }, {
    key: "initFrame",
    value: function initFrame(params) {
      // listen for iframe messages
      this.mapFrameEvents(); // create an iframe

      this.iframe = document.createElement('iframe');
      this.iframe.setAttribute('src', getFrameUrl(params, this.config.platform));
      this.iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin  allow-top-navigation allow-modals allow-popups');
      this.iframe.setAttribute('allow', 'camera; microphone;');
      this.iframe.setAttribute('width', '100%');
      this.iframe.setAttribute('height', '100%');
      this.iframe.setAttribute('border', 'none');
      this.iframe.style.border = 'none';
      var elmt = typeof params.element === 'string' ? document.querySelector(params.element) : params.element;
      elmt.innerHTML = '';
      elmt.appendChild(this.iframe);
    }
  }, {
    key: "mapFrameEvents",
    value: function mapFrameEvents() {
      registeredListener = this.handleMessage;
      window.addEventListener('message', registeredListener);
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(event) {
      var _this = this;

      if (event && event.data && event.data.idcheckio) {
        if (event.data.idcheckio.event === 'IFRAME_READY' && this.iframe) {
          // send configuration to iframe
          var msg = {
            idcheckio: {
              appId: 'Sdk-Web',
              resourceType: 'ONBOARDING',
              event: 'IFRAME_CONFIGURATION',
              data: _objectSpread2({}, this.config)
            }
          };
          waitForIframeReady(this.iframe).then(function () {
            return _this.iframe.contentWindow.postMessage(msg, '*');
          });
        } else {
          // trigger event callbacks
          var _event$data$idcheckio = event.data.idcheckio,
              type = _event$data$idcheckio.event,
              data = _objectWithoutProperties(_event$data$idcheckio, ["event"]);

          var callback = this.eventHandlers[type];

          if (callback) {
            callback(data);
          }
        }
      }
    }
  }, {
    key: "initLibrary",
    value: function initLibrary(params) {
      var _this2 = this;

      var _extractOnboardingDat = extractOnboardingData(params, this.config.platform),
          uid = _extractOnboardingDat.uid,
          platformUrl = _extractOnboardingDat.platformUrl;

      this.scriptLoader = new ScriptLoader(platformUrl);
      this.scriptLoader.injectConfig().then(function () {
        var remoteConfig = window.IdCheckIoConfig;

        _this2.scriptLoader.injectCore().then(function () {
          _this2.instance = new IdCheckIoCore(_objectSpread2(_objectSpread2({}, remoteConfig), _this2.config));
          Object.keys(_this2.eventHandlers).forEach(function (key) {
            _this2.instance.on(key, _this2.eventHandlers[key]);
          });

          _this2.instance.onLoadWidget(function (id) {
            return _this2.scriptLoader.injectWidget(id);
          });

          _this2.instance.onLoadLanguage(function (lang) {
            return _this2.scriptLoader.injectLang(lang);
          });

          _this2.instance.init({
            uid: uid,
            element: params.element
          });

          if (_this2.onReadyCallback) {
            _this2.onReadyCallback();
          }
        });
      });
    }
  }]);

  return IdCheckIo;
}();

export default IdCheckIo;
//# sourceMappingURL=idcheckio-sdk.esm.js.map
